export const PlatformTypes = {
    MAP_MANAGER: 'map_manager',
    ADMIN: 'admin'
};
